// @ts-nocheck
export type ShortcutConfig = {
  backupNeeded?: boolean;
  descriptionId: string;
  id: string;
  isFixed?: boolean;
  permissions?: boolean;
};

export const shortcutsConfig: ShortcutConfig[] = [
  {
    descriptionId: 'reporting.shortcuts.campaignInfo',
    id: 'reportingCampaignInfo',
    isFixed: true,
    permissions: true
  },
  {
    descriptionId: 'reporting.shortcuts.summary',
    id: 'reportingOverview'
  },
  {
    descriptionId: 'reporting.shortcuts.campaignProgress',
    id: 'reportingCharts'
  },
  {
    backupNeeded: true,
    descriptionId: 'reporting.shortcuts.insights',
    id: 'reportingInsights',
    permissions: true
  },
  {
    descriptionId: 'reporting.shortcuts.stats',
    id: 'reportingStatsTable'
  },
  {
    backupNeeded: true,
    descriptionId: 'reporting.shortcuts.viewabilityStats',
    id: 'reportingViewabilityTable',
    permissions: true
  },
  {
    descriptionId: 'reporting.shortcuts.footfallAttributionStats',
    id: 'reportingFootfallAttributionTable',
    permissions: true
  },
  {
    backupNeeded: true,
    descriptionId: 'reporting.shortcuts.footfallAttributionMap',
    id: 'reportingFootfallAttributionMap',
    permissions: true
  },
  {
    backupNeeded: true,
    descriptionId: 'reporting.shortcuts.map',
    id: 'reportingMap',
    permissions: true
  }
];
